import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import SegmentedToggle from 'components/SegmentedToggle';
import { TIMEFRAME_FILTER_COPY, TIMEFRAME_FILTER_OPTIONS } from './data';

import './TimeframeFilter.styles.scss';

type TimeframeFilterProps = {
  className?: string;
  selectedTimeframe: string;
  timeframeOptions?: string[];
  timeframeOptionsCopy?: Record<string, string>;
  onChangeTimeframe: (timeframe: string) => void;
};

const TimeframeFilter: React.FC<TimeframeFilterProps> = (props) => {
  const {
    className,
    selectedTimeframe,
    timeframeOptions = TIMEFRAME_FILTER_OPTIONS,
    timeframeOptionsCopy = TIMEFRAME_FILTER_COPY,
    onChangeTimeframe,
  } = props;

  const classes = classNames('timeframe-filter', className);

  const { t } = useTranslation();

  const options = useMemo(
    () =>
      timeframeOptions.map((timeframe) => ({
        value: timeframe,
        label: t(timeframeOptionsCopy[timeframe]),
      })),
    [t, timeframeOptions, timeframeOptionsCopy],
  );

  const handleChange = useCallback(
    (nextValue: string | number | boolean) =>
      onChangeTimeframe(nextValue as string),
    [onChangeTimeframe],
  );

  return (
    <div className={classes}>
      <SegmentedToggle
        options={options}
        selectedValue={selectedTimeframe}
        onChange={handleChange}
      />
    </div>
  );
};

export default TimeframeFilter;
